import { string, array } from 'yup'

export const inviteSchema = {
  email: string().required('Email é obrigatório').email('Email deve ser válido'),
  companyRolesIds: array().of(string()).min(1)
}
